module.exports = __webpack_public_path__ + "static/media/mob-app4.a3b0294b.jpg";